module.exports = __webpack_public_path__ + "img/Logout.a1a45399.png";